import {AuthGuard} from '../../shared/guards/AuthGuard';
import {ListagemContratosPresentation,DetalheContratosPresentation} from './components';
import {Sidebar} from '../../shared/components';


export const DetalheContratosPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <DetalheContratosPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};